import { render, staticRenderFns } from "./ModalRemoveSong.vue?vue&type=template&id=3ae8b706&scoped=true"
import script from "./ModalRemoveSong.vue?vue&type=script&lang=ts"
export * from "./ModalRemoveSong.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8b706",
  null
  
)

export default component.exports